import Vue from 'vue';
import EvalPopup from './eval-popup.vue';

const panelEval = document.querySelector('.eval-popup');

document.addEventListener('DOMContentLoaded', () => {
    if (isExists(panelEval)) {
        new Vue({
            el: '.eval-popup',
            components: { EvalPopup }
        });
    };
});



// WEBPACK FOOTER //
// ./frontend/components/eval-popup/eval-popup.js